import React from 'react';
import * as ReactRouterDOM from 'react-router-dom';
import { Header } from './Components/Header';
// import HeroEventsLayout from './Components/HeroEventsLayout';
import { About } from './Components/About';
import { Testimonials } from './Components/Testimonials';
import { Contact } from './Components/Contact';
import { Footer } from './Components/Footer';
import { Gallery } from './Page/Gallery';
import RoomsPage from './Components/RoomPage';
import "./App.css";
import HeroCarousel from './Components/HeroCarousel';
import RoomsAndSuits from './Components/RoomsAndSuits';
import MenuFlipBook from './Components/MenuFlipBook';
import PartyDetails from './Components/PartyDetails';

const App = () => {
  return (
    <ReactRouterDOM.BrowserRouter>
      <Header />
      <ReactRouterDOM.Routes>
        <ReactRouterDOM.Route
          path="/"
          element={
            <>
              {/* <HeroEventsLayout /> */}
              <HeroCarousel />
              <About />
              <RoomsAndSuits />
              <MenuFlipBook />
              <Testimonials />
              <Contact />
            </>
          }
        />
        <ReactRouterDOM.Route path="/gallery" element={<Gallery />} />
        <ReactRouterDOM.Route path="/rooms" element={<RoomsPage />} />
        <ReactRouterDOM.Route path="/party-details" element={<PartyDetails />} />
      </ReactRouterDOM.Routes>
      <Footer />
    </ReactRouterDOM.BrowserRouter>
  );
};

export default App;
